import GapsBetweenPlayersPerformance from "./GapsBetweenPlayersPerformance"
import WithoutFtdAndNetRev from "./WithoutFtdAndNetRev"


const AnomaliesBrands = () => {
  return (
    <>
    <WithoutFtdAndNetRev/>
    <GapsBetweenPlayersPerformance/>
    </>
  )
}

export default AnomaliesBrands